module.exports = __webpack_public_path__ + "static/media/10x81.0bc02dcc.png";